module.exports = __webpack_public_path__ + "blue.jpg?ba64bce05b77e688e5c6d313294a38e9";